import { FillCommand } from '../core/EditorActions.js';

/**
 * Flood fill tool — fills contiguous area of same tile ID.
 */
export class FillTool {
  constructor(state, mapCanvas, commandHistory) {
    this.state = state;
    this.mapCanvas = mapCanvas;
    this.commandHistory = commandHistory;
  }

  onDown(tx, ty) {
    const state = this.state;
    const layerIndex = state.get('activeLayerIndex');
    const layer = state.get('layers')[layerIndex];
    if (!layer || layer.type !== 'tilelayer') return;

    const mapW = state.get('mapWidth');
    const mapH = state.get('mapHeight');
    const newTile = state.get('selectedTileId');
    const targetTile = state.getTile(layerIndex, tx, ty);

    if (targetTile === newTile) return;
    if (tx < 0 || ty < 0 || tx >= mapW || ty >= mapH) return;

    const snapshot = new Uint32Array(layer.data);

    // DFS flood fill (stack-based, O(n) vs BFS shift O(n^2))
    const stack = [[tx, ty]];
    const visited = new Uint8Array(mapW * mapH);
    visited[ty * mapW + tx] = 1;

    while (stack.length > 0) {
      const [cx, cy] = stack.pop();
      layer.data[cy * mapW + cx] = newTile;

      const neighbors = [[cx - 1, cy], [cx + 1, cy], [cx, cy - 1], [cx, cy + 1]];
      for (const [nx, ny] of neighbors) {
        if (nx < 0 || ny < 0 || nx >= mapW || ny >= mapH) continue;
        const idx = ny * mapW + nx;
        if (visited[idx]) continue;
        visited[idx] = 1;
        if (layer.data[idx] === targetTile) {
          stack.push([nx, ny]);
        }
      }
    }

    const newSnapshot = new Uint32Array(layer.data);
    const cmd = new FillCommand(state, layerIndex, snapshot, newSnapshot);
    this.commandHistory.push(cmd);

    state.set('dirty', true);
    this.mapCanvas.invalidateLayer(layerIndex);
  }

  onMove() {}
  onUp() {}
}
